import { AddressRelatoryInteractor } from "../../Coordinator/AddressRelatory/AddressRelatoryInteractor";

export enum ConsolidatedReportType {
    district, neighborhood
}

export class AddressRelatoryViewModel {

    private interactor: AddressRelatoryInteractor
    constructor() {
        this.interactor = new AddressRelatoryInteractor()
    }


    public fetchAddress(filters: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchAddress(filters).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            })
        })
    }

    public fetchAddressRelatory(filters: any): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchAddressRelatory(filters).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            })
        })
    }
}